import React, { useContext, useEffect } from 'react'
import './index.scss'
import { Outlet } from 'react-router'
import { StoresContext } from '@App/contexts'

const RightsholderRegistrationLayout = () => {
    const { createRightsholderStore } = useContext(StoresContext)

    useEffect(() => {
        createRightsholderStore.loadQuestions().then()
    }, [])

    return (
        <>
            <title>Member registration</title>
            <main className="create-rightsholder-scene">
                <div className="global-container">
                    <div className="rightsholder-registration-scene-wrapper">
                        <Outlet />
                    </div>
                </div>
            </main>
        </>
    )
}

export default RightsholderRegistrationLayout
